import { useEffect, useRef } from "react";
import { trackEvent } from "./tracker";

export const useEmptyStateTracking = (
  rowCount: number | null | undefined,
  opts: { reason?: string } = {}
) => {
  const lastEmittedFor = useRef<string | null>(null);

  useEffect(() => {
    if (rowCount === null || rowCount === undefined) return;
    if (rowCount > 0) return;

    const key = `${window.location.pathname}${window.location.search}`;
    if (lastEmittedFor.current === key) return;
    lastEmittedFor.current = key;

    trackEvent("empty_state", {
      payload: { reason: opts.reason ?? null },
    });
  }, [rowCount, opts.reason]);
};
